import React from "react";
import "./patientMeasurement.scss";
import "../../steps/forms.scss";
import FormTitle from "../../components/formTitle/FormTitle";
import ShapeCreationRadio from "../../components/shapeCreationRadio/ShapeCreationRadio";
import MuiRadio from "../../components/radio/MuiRadio";
import RangeSlider from "../../components/range/RangeSlider";
import InputTextField from "../../components/textField/InputTextField";
import Brim from "../../components/brim/Brim";
import FieldState from "../../common/FieldState";
import axios from "axios";
import Config from "../../common/Config";
import OrderFormStep from "../../common/OrderFormStep";
import Button from "../../components/button/Button";
import SecondaryButton from "../../components/button/SecondaryButton";
import { Form } from "react-bootstrap";
import tfBodyPart from "../../images/tfBodyPart.png";
import { CreateNotification } from "../../components/notification/Notification";
import SaveAsDraft from "../../components/modal/SaveAsDraft";
import ClearOrder from "../../components/modal/ClearOrder";

const units = [
  { id: 1, number: 5 },
  { id: 2, number: 10 },
  { id: 3, number: 15 },
  { id: 4, number: 20 },
  { id: 5, number: 25 },
  { id: 6, number: 30 },
];

class TfMeasurement extends OrderFormStep {
  constructor(props) {
    super(props);

    this.fromCADFileId = 109;
    this.fromCastId = 98;
    this.fromScanId = 100;

    this.uomMetric = 67;
    this.UOM_InchId = 14;

    this.nextCartQueueIndex=0;
    this.displayedCartIndex=0;
    
    this.state = {
      shapeCreations: [],

      modifications: [],
      prostheticHeightUOMs: [],
      UOMs: [],

      brims: [],
      isSubmit: false,
      formState: {
        shapeCreation: new FieldState(true),
        cadFile: new FieldState(false),
        cadFileName: new FieldState(false),
        castShippedSeparately: new FieldState(false),
        scanFileName: new FieldState(false),
        modification: new FieldState(true),
        brim: new FieldState(true),
        myBrim: new FieldState(false),
        amount: new FieldState(false, 0),
        flexion: new FieldState(false, 3),
        adduction: new FieldState(false, 3),
        prostheticHeightUOM: new FieldState(false, this.uomMetric),
        UOM: new FieldState(true),
        ITToFloor: new FieldState(true),
        KCToFloor: new FieldState(true),
        Tight5cm: new FieldState(true),
        Tight10cm: new FieldState(true),
        Tight15cm: new FieldState(true),
        Tight20cm: new FieldState(true),
        Tight25cm: new FieldState(true),
        Tight30cm: new FieldState(true),
        Loose5cm: new FieldState(true),
        Loose10cm: new FieldState(true),
        Loose15cm: new FieldState(true),
        Loose20cm: new FieldState(true),
        Loose25cm: new FieldState(true),
        Loose30cm: new FieldState(true),
        LimbLength: new FieldState(true),
        FemurLength: new FieldState(true),
        notes: new FieldState(false),
        linerUsed: new FieldState(true),
      },
    };

    this.onFileChange = this.onFileChange.bind(this);
    this.onCheckChange = this.onCheckChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleFlexionChange = this.handleFlexionChange.bind(this);
    this.handleAdductionChange = this.handleAdductionChange.bind(this);
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }

    addToCart(this.state.shapeCreations, this.state.formState.shapeCreation.value, "shapeCreation");
    addToCart(this.state.modifications, this.state.formState.modification.value, "modification");

    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();

    return axios.get(
      Config.baseApiUrl + "price/" + this.props.formTypeId,
      config
    ).then(response => {
      let data = response.data

      cart = cart.map(c => {
        return {
          name: c.name,
          partNumber: c.partNumber,
          quantity: c.quantity,
          price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
          sourceId: c.sourceId
        }
      });

      cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
        return {
          name: d.name,
          partNumber: d.partNumber,
          quantity: d.quantity,
          price: d.price,
          sourceId: d.sourceId
        }
      }));

      if(this.shouldDisplayCart(index)) {
        this.props.setTempCart(cart);
      }
    }).catch(error =>{
      console.log(error)
    });
  }

  // onRadioChange(e) {
  //   super.onRadioChange(e);

  //   let formState = this.state.formState;
  //   formState.cadFile.isRequired = this.isFromCADFileSelected();
  //   formState.scanFileName.isRequired = this.isFromScanSelected();
  //   this.setState({ formState: formState, hasDataChanged: true });
  // }

  handleAmountChange(e, value) {
    let formState = this.state.formState;
    formState.amount.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleFlexionChange(e, value) {
    let formState = this.state.formState;
    formState.flexion.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleAdductionChange(e, value) {
    let formState = this.state.formState;
    formState.adduction.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  onFileChange(e) {
    let formState = this.state.formState;

    formState.cadFile.value = this.renameFile(e.target.files[0]);
    formState.cadFileName.value = "";
    formState.cadFile.isRequired = this.isFromCADFileSelected();

    console.log(formState.cadFile)
    this.setState({ formState: formState, hasDataChanged: true });
  }

  renameFile(file) {
    const oldName = file.name;
    const oldFileType = oldName.split(".").slice(-1);
    const newName = crypto.randomUUID() + "." + oldFileType;

    return new File([file], newName);
  }

  isFromCADFileSelected() {
    return this.state.formState.socketMaterial === this.fromCADFileId;
  }
  onCheckChange(e) {
    let formState = this.state.formState;
    formState.castShippedSeparately.value = e.target.checked;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  // onRadioChange(e) {
  //   super.onRadioChange(e);

  //   let formState = this.state.formState;
  //   formState.myBrim.isRequired = this.isMyBrimSelected();
  //   this.setState({ formState: formState, hasDataChanged: true });
  // }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    try {
      this.setState({
        shapeCreations: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "shapeCreation" },
            }
          )
        ).data,
        socketStyles: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "socketStyle" },
            }
          )
        ).data,
        trimlines: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "trimline" },
            }
          )
        ).data,
        modifications: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "modification" },
            }
          )
        ).data,

        brims: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "brim" } }
          )
        ).data,

        prostheticHeightUOMs: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "prostheticHeightUOM" } }
          )
        ).data,
        prostheticHeights: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "prostheticHeight" } }
          )
        ).data,
        UOMs: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "UOM" },
            }
          )
        ).data,
      });

      let formState = this.state.formState;

      let headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      };
      let cadFileConfig = {
        headers: headers,
      };

      const cadFile = (
        await axios.get(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          cadFileConfig
        )
      ).data;
      formState.cadFileName.value = cadFile !== null ? cadFile.cadFileName : "";

      let config = {
        headers: headers,
        params: {
          fieldNames: [
            "shapeCreation",
            "castShippedSeparately",
            "scanFileName",
            "modification",
            "brim",
            "brimOther",
            "flexion",
            "adduction",
            "prostheticHeightUOM",
            "prostheticHeight",
            "notes",
            "linerUsed",
            "modificationPercentage",
            "modificationPly",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );
      formState.shapeCreation.value = data.find(
        (fi) => fi.fieldName === "shapeCreation"
      ).fieldOptionId;

      if (formState.shapeCreation.value === 99) {
        this.loadMeasureData();
      }
      formState.castShippedSeparately.value = data.find(
        (fi) => fi.fieldName === "castShippedSeparately"
      ).booleanData;
      formState.scanFileName.value = data.find(
        (fi) => fi.fieldName === "scanFileName"
      ).stringData;

      formState.linerUsed.value = data.find(
        (fi) => fi.fieldName === "linerUsed"
      ).stringData;

      formState.notes.value = data.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;

      // formState.trimline.value = data.find(
      //   (fi) => fi.fieldName === "trimline"
      // ).fieldOptionId;

      // formState.socketStyle.value = data.find(
      //   (fi) => fi.fieldName === "socketStyle"
      // ).fieldOptionId;

      formState.modification.value = data.find(
        (fi) => fi.fieldName === "modification"
      ).fieldOptionId;

      formState.brim.value = data.find(
        (fi) => fi.fieldName === "brim"
      ).fieldOptionId;
      formState.myBrim.value = data.find(
        (fi) => fi.fieldName === "brimOther"
      ).stringData;

      formState.flexion.value =
        data.find((fi) => fi.fieldName === "flexion").numericData ?? 3;
      formState.adduction.value =
        data.find((fi) => fi.fieldName === "adduction").numericData ?? 3;

      if (this.state.formState.modification.value === 152) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "modificationPercentage"
        ).numericData;
      } else if (this.isPlySelected()) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "modificationPly"
        ).numericData;
      }

      // formState.prostheticHeightUOM.value =
      //   data.find((fi) => fi.fieldName === "prostheticHeightUOM")
      //     .fieldOptionId ?? this.uomMetric;
      // formState.prostheticHeight.value = data.find(
      //   (fi) => fi.fieldName === "prostheticHeight"
      // ).fieldOptionId;

      // formState.flexion.value =
      //   data.find((fi) => fi.fieldName === "flexion").numericData ?? 3;
      // formState.adduction.value =
      //   data.find((fi) => fi.fieldName === "adduction").numericData ?? 3;

      // if (this.state.formState.modification.value === 152) {
      //   formState.amount.value = data.find(
      //     (fi) => fi.fieldName === "modificationPercentage"
      //   ).numericData;
      // } else if (this.isPlySelected()) {
      //   formState.amount.value = data.find(
      //     (fi) => fi.fieldName === "modificationPly"
      //   ).numericData;
      // }

      formState.scanFileName.isRequired = this.isFromScanSelected();

      this.setState({ formState: formState });
      this.loadCart();
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    if (this.state.formState.shapeCreation.value !== 99) {
      this.setState({ isLoaded: true });
    }
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let fieldInputData = [];

    fieldInputData.push({
      fieldName: "shapeCreation",
      fieldOptionId: this.state.formState.shapeCreation.value,
    });

    fieldInputData.push({
      fieldName: "modification",
      fieldOptionId: this.state.formState.modification.value,
    });

    // fieldInputData.push({
    //   fieldName: "trimline",
    //   fieldOptionId: this.state.formState.trimline.value,
    // });

    // fieldInputData.push({
    //   fieldName: "socketStyle",
    //   fieldOptionId: this.state.formState.socketStyle.value,
    // });

    fieldInputData.push({
      fieldName: "castShippedSeparately",
      booleanData: this.state.formState.castShippedSeparately.value,
    });

    fieldInputData.push({
      fieldName: "modificationPercentage",
      numericData:
        this.state.formState.modification.value === 152
          ? this.state.formState.amount.value
          : null,
    });

    fieldInputData.push({
      fieldName: "modificationPly",
      numericData: this.isPlySelected()
        ? this.state.formState.amount.value
        : null,
    });

    fieldInputData.push({
      fieldName: "flexion",
      numericData: this.state.formState.flexion.value,
    });

    fieldInputData.push({
      fieldName: "adduction",
      numericData: this.state.formState.adduction.value,
    });

    // fieldInputData.push({
    //   fieldName: "prostheticHeight",
    //   fieldOptionId: this.state.formState.prostheticHeight.value,
    // });

    fieldInputData.push({
      fieldName: "linerUsed",
      stringData: this.state.formState.linerUsed.value,
    });

    fieldInputData.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });

    // fieldInputData.push({
    //   fieldName: "scanFileName",
    //   stringData: this.isFromScanSelected()
    //     ? this.state.formState.scanFileName.value
    //     : null,
    // });

    fieldInputData.push({
      fieldName: "brim",
      fieldOptionId: this.state.formState.brim.value,
    });

    // this.saveMeasureData();

    // fieldInputData.push({
    //   fieldName: "brimOther",
    //   stringData: this.isMyBrimSelected()
    //     ? this.state.formState.myBrim.value
    //     : null,
    // });

    let promises = [];

    const fields = [
      "UOM",
      "ITToFloor",
      "KCToFloor",
      "Tight5cm",
      "Tight10cm",
      "Tight15cm",
      "Tight20cm",
      "Tight25cm",
      "Tight30cm",
      "Loose5cm",
      "Loose10cm",
      "Loose15cm",
      "Loose20cm",
      "Loose25cm",
      "Loose30cm",
      "LimbLength",
      "FemurLength",
    ];

    if (this.state.formState.cadFile.value !== "") {
      const formData = new FormData();

      formData.append("cadFile", this.state.formState.cadFile.value);

      promises.push(
        axios.post(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          formData,
          config
        )
      );
    }
    if (this.state.formState.shapeCreation.value !== 99) {
      for (let i = 0; i < fields.length; i++) {
        this.state.formState[fields[i]].isRequired = false;
      }
    } else {
      for (let i = 0; i < fields.length; i++) {
        this.state.formState[fields[i]].isRequired = true;
      }
    }
    if (this.validateData().isValid) {
      if (this.state.formState.shapeCreation.value === 99) {
        promises.push(this.saveMeasureData());
      }
      promises.push(
        axios.post(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputData,
          config
        )
      );
      axios
        .all(promises)
        .then(
          axios.spread((res, res2) => {
            if (res2) {
              if (
                (res.status === 200 || res.status === 204) &&
                (res2.status === 200 || res2.status === 204)
              ) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            } else {
              if (res.status === 200 || res.status === 204) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            }
          })
        )
        .catch((error) => {
          console.log(error);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");
      this.setState({ isLoading: false });
    }
  }

  async shouldDisplay(formTypeId) {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
        },
        params: {
          fieldNames: ["shapeCreation"],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + formTypeId,
        config
      );

      return (
        data.find((fi) => fi.fieldName === "shapeCreation").fieldOptionId === 99
      );
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  async loadMeasureData() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
        },
        params: {
          fieldNames: [
            "UOM",
            "ITToFloor",
            "KCToFloor",
            "Tight5cm",
            "Tight10cm",
            "Tight15cm",
            "Tight20cm",
            "Tight25cm",
            "Tight30cm",
            "Loose5cm",
            "Loose10cm",
            "Loose15cm",
            "Loose20cm",
            "Loose25cm",
            "Loose30cm",
            "LimbLength",
            "FemurLength",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );

      let formState = this.state.formState;
      formState.UOM.value = data.find(
        (fi) => fi.fieldName === "UOM"
      ).fieldOptionId;
      formState.ITToFloor.value =
        data.find((fi) => fi.fieldName === "ITToFloor").numericData ?? "";
      formState.KCToFloor.value =
        data.find((fi) => fi.fieldName === "KCToFloor").numericData ?? "";
      formState.Tight5cm.value =
        data.find((fi) => fi.fieldName === "Tight5cm").numericData ?? "";
      formState.Tight10cm.value =
        data.find((fi) => fi.fieldName === "Tight10cm").numericData ?? "";
      formState.Tight15cm.value =
        data.find((fi) => fi.fieldName === "Tight15cm").numericData ?? "";
      formState.Tight20cm.value =
        data.find((fi) => fi.fieldName === "Tight20cm").numericData ?? "";
      formState.Tight25cm.value =
        data.find((fi) => fi.fieldName === "Tight25cm").numericData ?? "";
      formState.Tight30cm.value =
        data.find((fi) => fi.fieldName === "Tight30cm").numericData ?? "";
      formState.Loose5cm.value =
        data.find((fi) => fi.fieldName === "Loose5cm").numericData ?? "";
      formState.Loose10cm.value =
        data.find((fi) => fi.fieldName === "Loose10cm").numericData ?? "";
      formState.Loose15cm.value =
        data.find((fi) => fi.fieldName === "Loose15cm").numericData ?? "";
      formState.Loose20cm.value =
        data.find((fi) => fi.fieldName === "Loose20cm").numericData ?? "";
      formState.Loose25cm.value =
        data.find((fi) => fi.fieldName === "Loose25cm").numericData ?? "";
      formState.Loose30cm.value =
        data.find((fi) => fi.fieldName === "Loose30cm").numericData ?? "";
      formState.LimbLength.value =
        data.find((fi) => fi.fieldName === "LimbLength").numericData ?? "";
      formState.FemurLength.value =
        data.find((fi) => fi.fieldName === "FemurLength").numericData ?? "";

      this.setState({ formState: formState });
    } catch (error) {
      console.log(error);
      // this.props.handleError(new LoadFailureResult());
    }

    this.setState({ isLoaded: true });
  }

  saveMeasureData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = [];

    data.push({
      fieldName: "UOM",
      fieldOptionId: this.state.formState.UOM.value,
    });

    this.addNumericFieldInput(data, "ITToFloor");
    this.addNumericFieldInput(data, "KCToFloor");
    this.addNumericFieldInput(data, "Tight5cm");
    this.addNumericFieldInput(data, "Tight10cm");
    this.addNumericFieldInput(data, "Tight15cm");
    this.addNumericFieldInput(data, "Tight20cm");
    this.addNumericFieldInput(data, "Tight25cm");
    this.addNumericFieldInput(data, "Tight30cm");
    this.addNumericFieldInput(data, "Loose5cm");
    this.addNumericFieldInput(data, "Loose10cm");
    this.addNumericFieldInput(data, "Loose15cm");
    this.addNumericFieldInput(data, "Loose20cm");
    this.addNumericFieldInput(data, "Loose25cm");
    this.addNumericFieldInput(data, "Loose30cm");
    this.addNumericFieldInput(data, "LimbLength");
    this.addNumericFieldInput(data, "FemurLength");

    return axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      data,
      config
    );
  }

  addNumericFieldInput(data, fieldName) {
    data.push({
      fieldName: fieldName,
      numericData: this.state.formState[fieldName].value,
    });
  }

  handleSliderChange(newValue) {
    this.props.setActiveInnerStep(5);
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    const { setActiveInnerStep } = this.props;

    return (
      <>
        <div className="tfMeasuremnet">
          <div className="checkFormWrapper">
            <FormTitle
              title="Patient Measurement"
              description=""
            />

            <form className="checkform" onSubmit={e => {e.preventDefault()}}>
              <div className="">
                <ShapeCreationRadio
                  options={this.state.shapeCreations}
                  defaultValue={this.state.formState.shapeCreation.value}
                  error={
                    this.handleError("shapeCreation") && this.state.isSubmit
                  }
                  onChange={(e) => {
                    this.onRadioChange(e, "shapeCreation");
                  }}
                  fileChange={this.onFileChange}
                  fileName={this.state.formState.cadFileName.value}
                  measurement={
                    <div className="tfMeasuremnet">
                      <div className="measurementWrapper">
                        <MuiRadio
                          options={this.state.UOMs}
                          required={true}
                          defaultValue={this.state.formState.UOM.value}
                          label="Unit of Measurement"
                          onChange={(e) => {
                            this.onRadioChange(e, "UOM");
                            console.log(this.state.formState, "formStates");
                          }}
                        />
                        <div className="unitPic">
                          <div className="measurement">
                            <div className="level">
                              <div className="unitTitle">
                                <span>Level</span>
                                <span>Tight</span>
                                <span>Loose</span>
                              </div>

                              <div className="circumference">
                                <div className="unit tight">
                                  {units.map((unit) => (
                                    <div
                                      className="unitMeasurement"
                                      key={unit.id}
                                    >
                                      <p>
                                        {unit.number}{" "}
                                        {this.state.formState.UOM.value === 13
                                          ? "cm"
                                          : "inc"}
                                      </p>
                                    </div>
                                  ))}
                                </div>
                                <div className="inputFiledWrapper">
                                  <div className="inputFields">
                                    {this.getGridTextField("Tight5cm")}
                                    {this.getGridTextField("Tight10cm")}
                                    {this.getGridTextField("Tight15cm")}
                                    {this.getGridTextField("Tight20cm")}
                                    {this.getGridTextField("Tight25cm")}
                                    {this.getGridTextField("Tight30cm")}
                                  </div>
                                  <div className="inputFields">
                                    {this.getGridTextField("Loose5cm")}
                                    {this.getGridTextField("Loose10cm")}
                                    {this.getGridTextField("Loose15cm")}
                                    {this.getGridTextField("Loose20cm")}
                                    {this.getGridTextField("Loose25cm")}
                                    {this.getGridTextField("Loose30cm")}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="imgData">
                            <img
                              src={tfBodyPart}
                              alt="bodypart"
                              width="286px"
                              height="385"
                            />
                            <div className="inputs">
                              <div className="limb">
                                <InputTextField
                                  // variant="outlined"
                                  placeholder=""
                                  type="text"
                                  value={this.state.formState.LimbLength.value}
                                  error={
                                    this.handleError("LimbLength") &&
                                    this.state.isSubmit
                                  }
                                  onChange={(e) => {
                                    this.onInputChange(e, "LimbLength");
                                  }}
                                />
                              </div>

                              <div className="femur">
                                <InputTextField
                                  // variant="outlined"
                                  placeholder=""
                                  type="text"
                                  value={this.state.formState.FemurLength.value}
                                  error={
                                    this.handleError("FemurLength") &&
                                    this.state.isSubmit
                                  }
                                  onChange={(e) =>
                                    this.onInputChange(e, "FemurLength")
                                  }
                                />
                              </div>

                              <div className="kc">
                                <InputTextField
                                  // variant="outlined"
                                  placeholder=""
                                  type="text"
                                  value={this.state.formState.KCToFloor.value}
                                  error={
                                    this.handleError("KCToFloor") &&
                                    this.state.isSubmit
                                  }
                                  onChange={(e) => {
                                    this.onInputChange(e, "KCToFloor");
                                  }}
                                />
                              </div>

                              <div className="floor">
                                <InputTextField
                                  // variant="outlined"
                                  placeholder=""
                                  type="text"
                                  width="60px"
                                  value={this.state.formState.ITToFloor.value}
                                  error={
                                    this.handleError("ITToFloor") &&
                                    this.state.isSubmit
                                  }
                                  onChange={(e) =>
                                    this.onInputChange(e, "ITToFloor")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                />
              </div>

              <div className="fieldBorder">
                <Brim
                  options={this.state.brims}
                  defaultValue={this.state.formState.brim.value}
                  error={this.handleError("brim") && this.state.isSubmit}
                  required={this.state.formState["brim"].isRequired}
                  onChange={(e) => {
                    setActiveInnerStep(1);
                    this.onRadioChange(e, "brim");
                  }}
                />
              </div>

              <div className="fieldBorder fieldMargin filedWidth">
                <MuiRadio
                  options={this.state.modifications}
                  defaultValue={this.state.formState.modification.value}
                  label="Modifications"
                  error={
                    this.handleError("modification") && this.state.isSubmit
                  }
                  required={this.state.formState["modification"].isRequired}
                  onChange={(e) => {
                    setActiveInnerStep(2);
                    this.onRadioChange(e, "modification");
                  }}
                />

                <div className="fieldWrapper ">{this.showAmount()}</div>
                <InputTextField
                  label="Liner Model/Name used for Cast or Scan"
                  variant="outlined"
                  placeholder="Liner Model"
                  type="text"
                  error={
                    this.handleError("modification") && this.state.isSubmit
                  }
                  required={this.state.formState["linerUsed"].isRequired}
                  margin={true}
                  value={this.state.formState.linerUsed.value}
                  onChange={(e) => {
                    this.onInputChange(e, "linerUsed");
                    console.log(this.state.formState.linerUsed.value);
                  }}
                />
              </div>

              <div className="fieldBorder ">
                <h4 className="headLable">Angles</h4>
                <div className="fieldWrapper">
                  <div className="rangeSlider">
                    <RangeSlider
                      label={this.showFlexion()}
                      min={-10}
                      max={10}
                      step={1}
                      unit="°"
                      marks={""}
                      minValue={"Extension"}
                      maxValue={"Flexion"}
                      initialValue={this.state.formState.flexion.value}
                      onChange={(e) => {
                        this.handleFlexionChange(e);
                        this.props.setActiveInnerStep(4);
                      }}
                    />

                    <RangeSlider
                      label={this.showAdduction()}
                      min={-10}
                      max={10}
                      step={1}
                      unit="°"
                      marks={""}
                      minValue={"Abduction"}
                      maxValue={"Adduction"}
                      initialValue={this.state.formState.adduction.value}
                      onChange={(e) => {
                        this.handleAdductionChange(e);
                        this.props.setActiveInnerStep(4);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="msgBox msgBoxWidth">
                <h4 className="headLable">Measurement Notes</h4>
                <InputTextField
                  label="Measurement Notes"
                  variant="outlined"
                  placeholder="Type Something here..."
                  required={this.state.formState["notes"].isRequired}
                  multiline
                  rows={6}
                  value={this.state.formState.notes.value}
                  error={this.handleError("notes") && this.state.isSubmit}
                  onChange={(e) => {
                    setActiveInnerStep(4);
                    this.onInputChange(e, "notes");
                  }}
                />
              </div>
            </form>
          </div>
          <div className="handelButtons">
            <SecondaryButton
              text="Save As Draft"
              onClick={this.props.handleClickOpen}
            />
            <SecondaryButton
              text = "Clear the Order?"
              onClick = {this.props.handleClickClearOpen}
            />
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep === 0 && this.props.innerStep === 0
                }
              />
              <Button
                text="Next"
                disabled={this.state.isLoading}
                onClick={async () => {
                  this.setState({ isLoading: true });
                  this.saveData();
                }}
              />
            </div>
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />
      </>
    );
  }

  showAmount() {
    if (this.isPercentageSelected() || this.isPlySelected()) {
      return (
        <Form.Group controlId="amount">
          <div className="range">
            <RangeSlider
              min={-10}
              max={10}
              step={1}
              minValue={"-10"}
              maxValue={"+10"}
              unit={this.getAmountText()}
              label={`Amount`}
              initialValue={this.state.formState.amount.value}
              onChange={(e) => this.handleAmountChange(e)}
              valueLabelDisplay="auto"
              aria-labelledby="continuous-slider-always"
            />
          </div>
        </Form.Group>
      );
    }
  }

  getAmountText() {
    let amountText;
    let amount = this.state.formState.amount.value;

    if (this.isPercentageSelected()) {
      amountText = "%";
    } else {
      amountText = " Ply";
    }

    if (amount >= 0) {
      amountText += " Increase";
    } else {
      amountText += " Reduction";
    }

    return amountText;
  }

  isPercentageSelected() {
    return this.state.formState.modification.value === 152;
  }

  isPlySelected() {
    return this.state.formState.modification.value === 153;
  }

  showFlexion() {
    let flexion = this.state.formState.flexion.value;
    let directionPrefix;
    if (flexion >= 0) {
      directionPrefix = "Flexion: ";
    } else {
      directionPrefix = "Extension: ";
    }

    return directionPrefix + Math.abs(flexion) + "°";
  }

  showAdduction() {
    let adduction = this.state.formState.adduction.value;
    let directionPrefix;
    if (adduction >= 0) {
      directionPrefix = "Adduction: ";
    } else {
      directionPrefix = "Abduction: ";
    }

    return directionPrefix + Math.abs(adduction) + "°";
  }

  getAbsValue(value) {
    return Math.abs(value);
  }

  getIntervalFromCM(cm) {
    if (this.state.formState.UOM.value === this.UOM_InchId) {
      return `${cm / 2.5} in`;
    } else {
      return `${cm} cm`;
    }
  }

  getGridTextField(fieldName) {
    return (
      <>
        <InputTextField
          variant="outlined"
          placeholder="Enter Value"
          type="number"
          required
          value={this.state.formState[fieldName].value}
          error={this.handleError(fieldName) && this.state.isSubmit}
          onChange={(e) => this.onInputChange(e, fieldName)}
        />
      </>
    );
  }
}

export default TfMeasurement;
